import React from "react";

/**
 * One labelled company-settings field. Accessible by construction: the label is
 * bound with htmlFor/id, the error is referenced with aria-describedby and
 * aria-invalid, and the help text is part of the same description.
 */
export const CompanyField = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  error,
  help,
  type = "text",
  multiline = false,
  rows = 4,
  maxLength,
  required = false,
  testId,
  inputMode,
}) => {
  const errorId = error ? `${id}-error` : undefined;
  const helpId = help ? `${id}-help` : undefined;
  const describedBy = [errorId, helpId].filter(Boolean).join(" ") || undefined;
  const common = {
    id,
    value: value || "",
    disabled,
    maxLength,
    // aria-required, NOT the native `required` attribute: native constraint
    // validation would block the submit event before the Bulgarian validator
    // in companyValidation.js could render its message.
    "aria-required": required ? "true" : undefined,
    "aria-invalid": error ? "true" : undefined,
    "aria-describedby": describedBy,
    "data-testid": testId,
    onChange: (e) => onChange(e.target.value),
  };

  return (
    <div className="qw-field">
      <label htmlFor={id}>{label}</label>
      {multiline ? (
        <textarea className="qw-textarea" rows={rows} {...common} />
      ) : (
        <input className="qw-input" type={type} inputMode={inputMode} {...common} />
      )}
      {help && (
        <div className="qw-help" id={helpId}>
          {help}
        </div>
      )}
      {error && (
        <div className="qw-error" id={errorId} data-testid={`${testId}-error`}>
          {error}
        </div>
      )}
    </div>
  );
};

export default CompanyField;
